var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"no-fade":_vm.noFade,"no-wrap":_vm.noWrap,"opacity":_vm.opacity,"rounded":_vm.rounded,"show":_vm.show,"spinner-type":_vm.spinnerType,"variant":_vm.color,"z-index":_vm.zIndex}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }